import React, { useEffect, useState, useRef } from 'react';
import { Button, Input, Balloon } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import LzDialog from '@/components/common/LzDialog';
import Dialog_CrowdSmsTemplate from '@/components/CrowdSmsTemplate';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import TopTitle from '@/components/UI/TopTitle';
import styles from './index.module.scss';
import CONSTANTS from '@/utils/constant';

const PushInvitate = (props) => {
  const mountedRef = useRef(true);
  const isViewMode = Number(props.checkType) === 3;

  // 短信模板弹窗
  const [selectSmsTemplateDialog, setSelectSmsTemplateDialog] = useState(false);
  // 已输入字数
  const [sizeLength, setSizeLength] = useState(0);
  // 每条短信算几条
  const [everyMessageNum, setEveryMessageNum] = useState(1);
  // 用于提交的短信内容（模板原始内容）
  const [checkSmsContent, setCheckSmsContent] = useState('');
  // 模板信息（测试短信用）
  const [smsTemplateInfo, setSmsTemplateInfo] = useState({
    templateId: '',
    smsAccount: '',
    fullContent: '',
  });
  // 账户余额
  const [accountRemain, setAccountRemain] = useState(1000);
  // 测试手机号
  const [testTel, setTestTel] = useState('');
  // 手机预览内容
  const [phoneMsgSecond, setPhoneMsgSecond] = useState('');

  // 获取短信余额
  const getPaymentRecord = (isReFresh = false) => {
    Servlets('getPageSmsNum').then((res: { data: number }) => {
      if (!mountedRef.current) return;
      if (res.data === undefined) return;
      setAccountRemain(res.data);
      if (isReFresh) LzMsg.success('余额已刷新');
    });
  };

  useEffect(() => {
    getPaymentRecord();
    return () => {
      mountedRef.current = false;
    };
  }, []);

  // 选择短信模板回调
  const dealSmsContent = (tmp) => {
    // 设置短信内容（展示用，不含签名）
    const temp = { ...props.params };
    temp.smsContent = tmp.templateShowContent;
    temp.smsModelId = tmp.templateId;
    // 清空长短链（新模板组件不提供链接信息）
    temp.smsShortUrl = '';
    temp.smsLongUrl = '';
    props.setInvitateInfo(temp);

    // 暂存模板信息，来判断用户是否更改模板内容
    props.setTemplate({
      id: tmp.templateId,
      content: tmp.templateShowContent,
    });

    // 清空长短链
    props.setLink({ long: '', short: '' });

    // 用于提交的模板内容
    setCheckSmsContent(tmp.templateContent);

    // 模板信息（测试短信用）
    setSmsTemplateInfo({
      templateId: tmp.templateId,
      smsAccount: tmp.smsAccount,
      fullContent: tmp.fullContent,
    });

    // 字数和计费（smsSplitNum 格式如 "70/1"）
    setSizeLength(tmp.smsSplitNum ? +tmp.smsSplitNum.split('/')[0] : 0);
    setEveryMessageNum(tmp.smsSplitNum ? +tmp.smsSplitNum.split('/')[1] : 1);

    // 设置测试短信内容
    props.setTestParams({
      ...props.testParams,
      fullContent: `${tmp.templateShowContent} ${CONSTANTS.LZ_SMS_CANCEL_WORD}`,
    });

    // 关闭弹窗
    setSelectSmsTemplateDialog(false);
  };

  // 发送测试短信
  const sendTestTel = () => {
    if (!testTel) {
      LzMsg.warning('请输入您的手机号码后发送测试！');
      return;
    }
    if (!utils.telphoneVerification(testTel)) {
      LzMsg.warning('请正确填写您的手机号码！');
      return;
    }
    if (!props.params.smsContent) {
      LzMsg.error('请选择短信模板');
      return;
    }

    const fullContent = {
      fullContent: checkSmsContent || props.params.smsContent,
      mobile: testTel,
      channelType: 1,
      replace: 1,
      sign: props.params.smsSign,
      smsAccount: smsTemplateInfo.smsAccount,
      templateId: smsTemplateInfo.templateId,
      templateParam: '',
    };
    Servlets('sendTestsms', fullContent).then((res) => {
      if (res.success) {
        LzMsg.success('发送成功');
      } else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      LzMsg.error(e.message);
    });
  };

  // 短信预览内容：签名 + 内容 + 退订词
  useEffect(() => {
    const signs = props.params.smsSign ? `【${props.params.smsSign}】` : '【】';
    let cont = props.params.smsContent ? props.params.smsContent : '';
    cont = cont?.replace(/\n/g, '<br/>');
    cont = cont?.replace(/\s/g, '&nbsp;');
    const cancelWord = isViewMode && +props.createTime < CONSTANTS.UP_TIME ? '' : CONSTANTS.LZ_SMS_CANCEL_WORD;
    setPhoneMsgSecond(`${signs}${cont}${cancelWord ? ' ' + cancelWord : ''}`);
  }, [props.params.smsContent, props.params.smsSign]);

  // 余额是否充足
  useEffect(() => {
    props.setEnough(accountRemain > props.forNum * everyMessageNum);
  }, [props.forNum, accountRemain, everyMessageNum]);

  console.log(props.params, '=============');

  return (
    <div
      style={{
        marginBottom: '20px',
        background: 'white',
        padding: '20px',
        borderRadius: '5px',
      }}
    >
      <TopTitle title="投放内容" />
      <div className={styles.newCopyCon}>
        <div className={styles.newCopyEdit}>
          <div className={styles.newCopyLeft}>
            {/* 短信签名 */}
            <div style={{ display: 'flex', marginBottom: '30px' }}>
              <div
                style={{
                  width: '20%',
                  height: '30px',
                  lineHeight: '30px',
                  textAlign: 'right',
                  paddingRight: '10px',
                }}
              >
                <span>短信签名：</span>
              </div>
              <div style={{ width: '80%' }}>
                <Input
                  disabled
                  value={props.params.smsSign}
                  style={{ width: '80%' }}
                />
                {!isViewMode ? (
                  <Button
                    style={{ paddingLeft: '10px' }}
                    text
                    type="primary"
                    onClick={() => {
                      window.open('../../../../subsms/private/sms/sign');
                    }}
                  >
                    修改短信签名
                  </Button>
                ) : (
                  <Button
                    style={{ paddingLeft: '10px' }}
                    disabled
                    text
                    type="primary"
                  >
                    修改短信签名
                  </Button>
                )}
              </div>
            </div>

            {/* 短信内容 */}
            <div style={{ display: 'flex', marginBottom: '15px' }}>
              <div className={styles['title-box1']} style={{ lineHeight: '25px' }}>
                <span><span className={styles.red}>*</span>短信内容：</span>
              </div>
              <div style={{ width: '80%' }}>
                <div>
                  <Button
                    type="secondary"
                    size="small"
                    className={`${styles.w88} ${styles.mr10}`}
                    style={{
                      borderRadius: '2px',
                      height: '30px',
                      padding: 0,
                    }}
                    disabled={isViewMode}
                    onClick={() => {
                      setSelectSmsTemplateDialog(true);
                    }}
                  >
                    选择短信模板
                  </Button>
                </div>

                <div style={{ display: 'flex', marginTop: '5px' }}>
                  <div style={{ marginTop: '10px', width: '80%' }}>
                    <Input.TextArea
                      placeholder="请选择短信模板"
                      aria-label="TextArea"
                      style={{
                        width: '100%',
                        paddingTop: '5px',
                        marginRight: '10px',
                      }}
                      className={styles.messageContent}
                      value={props.params.smsContent}
                      rows={7}
                      disabled
                    />

                    {/* 余额信息栏 */}
                    <div
                      style={{
                        backgroundColor: '#F5F7F9',
                        marginTop: '15px',
                        width: '100%',
                        height: '50px',
                        display: 'flex',
                        lineHeight: '50px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <div
                        className="iconfont icon-iconxx-32"
                        style={{
                          fontSize: '26px',
                          paddingLeft: '20px',
                          paddingRight: '20px',
                          color: '#9CA7B6',
                        }}
                      />
                      <div>
                        当前账户余额:
                        <span
                          style={{ paddingLeft: '5px', paddingRight: '5px' }}
                          className={styles.red}
                        >
                          {accountRemain.toLocaleString()}
                        </span>
                        条
                      </div>
                      <div style={{ marginLeft: 'auto', paddingRight: '15px' }}>
                        {!isViewMode ? (
                          <Button
                            text
                            type="primary"
                            style={{ marginLeft: '10px' }}
                            onClick={() => {
                              getPaymentRecord(true);
                            }}
                          >
                            刷新余额
                          </Button>
                        ) : (
                          <Button
                            text
                            type="primary"
                            disabled
                            style={{ marginLeft: '10px' }}
                          >
                            刷新余额
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* 字数/计费/规则 */}
                  <div
                    style={{
                      marginTop: '10px',
                      lineHeight: '22px',
                      position: 'relative',
                      left: '10px',
                    }}
                  >
                    <div>
                      已输入：
                      <span
                        className={styles.red}
                        style={{ paddingRight: '2px' }}
                      >
                        {sizeLength}
                      </span>
                      /350 字(包含签名)
                    </div>
                    <div>
                      当前计费：
                      <span
                        className={styles.red}
                        style={{ paddingRight: '5px' }}
                      >
                        {everyMessageNum}
                      </span>
                      条
                    </div>
                    <div>
                      <Balloon
                        trigger={
                          <span
                            style={{
                              margin: '5px',
                              color: '#3399FF',
                              marginLeft: '0',
                              cursor: 'pointer',
                            }}
                          >
                            计费及内容规则
                          </span>
                        }
                        align="r"
                        closable={false}
                      >
                        <div>
                          <div style={{ fontWeight: 'bold' }}>说明</div>
                          <div>
                            1、70字计一条短信收费，超出70字按67字每条计，一个汉字，字母或者标点都算一个字<br/>
                            2、受短信运营商限制，签名和{CONSTANTS.LZ_SMS_CANCEL_WORD}，包含在字数中<br/>
                            3、请确保短链接【前后各加一个空格】，否则智能手机无法打开，使用短链接工具生成的短链已默认增加前后空格<br/>
                            4、请确保每条短信中只有一条短链接，否则无法统计短信发送情况<br/>
                            5、短信内容只能为普通字符，不能包含：【、】、）、表情符 等特殊字符
                          </div>
                        </div>
                      </Balloon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 测试短信接收人电话 */}
            <div
              style={{
                display: 'flex',
                marginBottom: '15px',
                marginTop: '30px',
              }}
            >
              <div
                style={{
                  width: '20%',
                  height: '30px',
                  lineHeight: '30px',
                  textAlign: 'right',
                  paddingRight: '10px',
                }}
              >
                <span>测试短信接收人电话：</span>
              </div>
              <div style={{ width: '80%' }}>
                <Input
                  showLimitHint
                  maxLength={11}
                  placeholder="请输入手机号"
                  value={testTel}
                  hasClear
                  onChange={(v) => setTestTel(String(v))}
                  style={{ width: 300, marginRight: 10 }}
                  disabled={isViewMode}
                />
                {!isViewMode && (
                  <Button
                    type="secondary"
                    style={{ width: '88px', padding: 0 }}
                    onClick={sendTestTel}
                  >
                    发送测试
                  </Button>
                )}
              </div>
            </div>
          </div>

          {/* 手机实时预览 */}
          <div className={styles.newCopyRight}>
            <div className={styles.phoneBox}>
              <div className={styles.phoneImg}>
                <div
                  className={styles.previewMessage}
                  dangerouslySetInnerHTML={{ __html: `${phoneMsgSecond}` }}
                />
              </div>
              <div
                style={{
                  marginLeft: '170px',
                  width: '60px',
                  marginTop: '15px',
                  color: '#657180',
                }}
              >
                实时预览
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 选择短信模板弹窗 */}
      <LzDialog
        isFullScreen
        shouldUpdatePosition
        visible={selectSmsTemplateDialog}
        footer={false}
        title="选择短信模板"
        onCancel={() => setSelectSmsTemplateDialog(false)}
        onClose={() => setSelectSmsTemplateDialog(false)}
        style={{ width: 1060 }}
      >
        <Dialog_CrowdSmsTemplate
          diySelect={(tem) => dealSmsContent(tem)}
          systemSelect={(tem) => dealSmsContent(tem)}
          historySelect={(tem) => dealSmsContent(tem)}
          modelTypeCode={'S_DDSXYX'}
        />
      </LzDialog>
    </div>
  );
};

export default PushInvitate;
